import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Stonks: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_33532)'>
        <path
          d='M7.66737 15.7422H3.45485C3.22962 15.7422 3.04688 15.9249 3.04688 16.1502V22.5875C3.04688 22.8128 3.22962 22.9955 3.45485 22.9955H7.66846C7.8937 22.9955 8.07644 22.8128 8.07644 22.5875L8.07537 16.1502C8.07537 15.9249 7.89261 15.7422 7.66737 15.7422ZM7.25939 22.1795H3.86283V16.5581H7.26048L7.25939 22.1795Z'
          fill='url(#paint0_linear_12280_33532)'
          stroke='url(#paint1_linear_12280_33532)'
          strokeWidth='0.7'
        />
        <path
          d='M14.3833 11.9023H10.1697C9.94446 11.9023 9.76172 12.0851 9.76172 12.3103V22.5884C9.76172 22.8136 9.94446 22.9964 10.1697 22.9964H14.3833C14.6085 22.9964 14.7913 22.8136 14.7913 22.5884V12.3103C14.7913 12.0851 14.6085 11.9023 14.3833 11.9023ZM13.9753 22.1804H10.5777V12.7183H13.9753V22.1804Z'
          fill='url(#paint2_linear_12280_33532)'
          stroke='url(#paint3_linear_12280_33532)'
          strokeWidth='0.7'
        />
        <path
          d='M21.1001 6.68359H16.8865C16.6613 6.68359 16.4785 6.86634 16.4785 7.09157V22.5926C16.4785 22.8178 16.6613 23.0006 16.8865 23.0006H21.1001C21.3253 23.0006 21.5081 22.8178 21.5081 22.5926V7.09157C21.5081 6.86634 21.3253 6.68359 21.1001 6.68359ZM20.6921 22.1846H17.2945V7.49955H20.6921V22.1846Z'
          fill='url(#paint4_linear_12280_33532)'
          stroke='url(#paint5_linear_12280_33532)'
          strokeWidth='0.7'
        />
        <path
          d='M3.17054 13.6452L7.65205 7.55843L11.579 9.26683C11.7585 9.34439 11.9678 9.28489 12.0783 9.1234L16.479 2.72112V4.71426C16.479 4.9395 16.6618 5.12224 16.887 5.12224C17.1123 5.12224 17.295 4.9395 17.295 4.71426V1.40692C17.295 1.40267 17.2939 1.39948 17.2939 1.39523C17.2929 1.36973 17.2908 1.3453 17.2854 1.32086C17.2833 1.3113 17.2801 1.30173 17.2769 1.29217C17.2716 1.27411 17.2653 1.25605 17.2568 1.23799C17.2525 1.22842 17.2472 1.21886 17.2419 1.2093C17.2323 1.1923 17.2228 1.17743 17.2111 1.16149C17.2047 1.15299 17.1983 1.14449 17.1909 1.13599C17.1771 1.12112 17.1622 1.10731 17.1473 1.09456C17.1409 1.08925 17.1367 1.08393 17.1303 1.07862C17.1282 1.07756 17.1261 1.0765 17.1239 1.07543C17.1218 1.07331 17.1197 1.07118 17.1176 1.07012C17.0974 1.05631 17.0761 1.04569 17.0549 1.03612C17.0528 1.03612 17.0496 1.034 17.0475 1.03187C17.0188 1.02019 16.9911 1.01275 16.9625 1.00637C16.955 1.00531 16.9476 1.00531 16.9401 1.00425C16.9189 1.00106 16.8966 1 16.8753 1C16.8658 1 16.8551 1.00212 16.8456 1.00319C16.8265 1.00531 16.8073 1.0085 16.7882 1.01275C16.7818 1.01381 16.7765 1.01381 16.7702 1.01594L13.2705 2.06031C13.0548 2.12512 12.9316 2.35247 12.9964 2.56816C13.0612 2.7849 13.2896 2.90602 13.5043 2.84227L15.8958 2.1283L11.596 8.38398L7.67996 6.67982C7.50465 6.60439 7.30173 6.65857 7.18804 6.81157L2.51315 13.1619C2.37928 13.3436 2.41859 13.5986 2.59921 13.7324C2.67252 13.7856 2.75645 13.8121 2.84145 13.8121C2.96682 13.8111 3.09006 13.7537 3.17079 13.6453L3.17054 13.6452Z'
          fill='url(#paint6_linear_12280_33532)'
          stroke='url(#paint7_linear_12280_33532)'
          strokeWidth='0.7'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_33532'
          x1='4.08838'
          y1='16.2368'
          x2='8.01101'
          y2='21.6884'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_33532'
          x1='4.08838'
          y1='16.2368'
          x2='8.01101'
          y2='21.6884'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_33532'
          x1='10.8032'
          y1='12.6588'
          x2='17.102'
          y2='18.3822'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_33532'
          x1='10.8032'
          y1='12.6588'
          x2='17.102'
          y2='18.3822'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_33532'
          x1='17.52'
          y1='7.79623'
          x2='25.8427'
          y2='12.938'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_33532'
          x1='17.52'
          y1='7.79623'
          x2='25.8427'
          y2='12.938'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint6_linear_12280_33532'
          x1='5.51105'
          y1='1.87364'
          x2='10.816'
          y2='14.207'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint7_linear_12280_33532'
          x1='5.51105'
          y1='1.87364'
          x2='10.816'
          y2='14.207'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_33532'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Stonks;
